import { render, staticRenderFns } from "./container.page.vue?vue&type=template&id=4b5e7de2"
import script from "./container.page.vue?vue&type=script&lang=ts"
export * from "./container.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports